require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-vision-behind-yarrabends-wellness-centre.json") })
        }
      }, "path---news-the-vision-behind-yarrabends-wellness-centre");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-vision-behind-yarrabends-wellness-centre!./.cache/json/news-the-vision-behind-yarrabends-wellness-centre.json
// module id = 858
// module chunks = 231608221292675